 <template>
  <div class="user-management" ref="userManagement">
    <div class="form-area" ref="form">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        label-position="left"
        label-width="72px"
      >
        <el-form-item label="用户姓名：">
          <el-input v-model.trim="form.realname" placeholder="请输入用户姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户状态：">
          <el-select v-model="form.status" clearable placeholder="请选择用户状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="锁定" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch">查询</el-button>
          <el-button type="primary" size="small" @click="onAddUser">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      stripe
      :height="tableHeight"
    >
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="头像">
        <template slot-scope="scope">
          <img
            v-if="getAvatar(scope.row.avatar)"
            :src="getAvatar(scope.row.avatar)"
            width="40"
            height="40"
            class="avatarImg"
          />
          <img
            v-else
            :src="scope.row.gender===1?'/images/headboy.png':'/images/headgirl.png'"
            width="40"
            height="40"
            class="avatarImg"
          />
        </template>
      </el-table-column>
      <el-table-column prop="realname" label="姓名"></el-table-column>
      <el-table-column prop="gender" label="性别" width="50">
        <template slot-scope="scope">{{scope.row.gender===1 ? "男" :"女"}}</template>
      </el-table-column>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="phone" label="电话" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deptId" label="企业" width="210" :show-overflow-tooltip="true">
        <template
          slot-scope="scope"
        >{{scope.row.department?(scope.row.department.name?scope.row.department.name:''):''}}</template>
      </el-table-column>
      <el-table-column prop="status" label="是否锁定用户状态" width="150">
        <template slot-scope="scope">
          <el-switch
            @change="changeStatus($event,scope.row)"
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <!-- <el-button
            type="text"
            size="small"
            :sort="scope.row.status === 0 ? 'primary' : 'danger'"
          >{{ scope.row.status === 0 ? "正常" : "锁定" }}</el-button>-->
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-edit-outline"
            type="text"
            size="small"
            sort="primary"
            @click="onUpdateUser(scope.row)"
          >编辑</el-button>
          <el-button
            icon="el-icon-zoom-out"
            type="text"
            size="small"
            sort="authorize"
            @click="onResetPassword(scope.row)"
          >重置密码</el-button>
          <el-button
            icon="el-icon-delete"
            type="text"
            size="small"
            sort="danger"
            @click="onDeleteUser(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" ref="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="form.size"
        :current-page="form.current"
        @current-change="onCurrentChange"
      ></el-pagination>
    </div>
    <el-dialog :title="title" v-if="dialogVisible" :visible.sync="dialogVisible" width="30%">
      <div>
        <div class="body"></div>
        <addUser ref="addUser" :userId="userId" @onDialogClose="onDialogClose" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="small" @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="onSave"
        >{{ title.indexOf("新增") !== -1 ? "新增" : "保存"}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

  <script>
import addUser from "./components/addUser.vue";
import {
  getUserListByField,
  deleteUser,
  updateUser,
  updateUserStatus,
  resetPsw,
  IMG_PREFIX,
} from "@/api/lib/api.js";
export default {
  name: "userManagement",
  components: {
    addUser,
  },
  data () {
    return {
      tableHeight: 0,
      total: 0,
      tableData: [],
      form: {
        realname: "",
        status: 0,
        current: 1,
        offset: null,
        size: 10,
      },
      multipleSelection: [],
      title: "",
      userId: "",
      dialogVisible: false,
    };
  },
  methods: {
    // 计算表格高度
    computeHeight () {
      let wholeHeight = this.$refs.userManagement.clientHeight;
      let formHeight = this.$refs.form.clientHeight;
      let paginationHeight = this.$refs.pagination.clientHeight;
      this.tableHeight =
        wholeHeight - 16 - formHeight - paginationHeight - 10 - 16 - 35;
    },
    // 点击查询
    onSearch () {
      this.form.current = 1;
      this.getUserListByField(this.form);
    },
    //获取数据
    getUserListByField (data) {
      getUserListByField(data).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          if (!res.data.records.length && this.form.current !== 1) {
            //如果当前页的数据为0则设置页面为前一页 但是确保当前页不为1
            self.form.current -= 1;
            self.getUserListByField(this.form);
          }
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.message);
        }
      });
    },
    //新增
    onAddUser () {
      this.userId = "";
      this.title = "新增用户";
      this.dialogVisible = true;
    },
    // 点击表格查看按钮
    onUpdateUser (row) {
      this.title = "修改用户信息";
      this.userId = row.id;
      this.dialogVisible = true;
    },
    // 修改用户状态
    changeStatus (e, row) {
      //console.log('ghggjgghgjh',row.id)
      let message = e === 1 ? "锁定" : "启用";
      updateUserStatus({ id: row.id, status: e }).then((res) => {
        if (res.code === 0) {
          this.$message.success(`${message}成功`);
        } else {
          this.$message.error(`${message}失败`);
          row.status = e === 1 ? 0 : 1;
          //console.log(111,row)
        }
      });
    },
    // 删除 用户
    onDeleteUser (row) {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        type: "warning",
        message: h("p", null, [
          h("span", null, "确定删除用户 "),
          h("i", { style: "color: #059370" }, row.realname),
          h("span", null, " ？"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          deleteUser(row.id).then((res) => {
            if (res.code === 0) {
              this.$message.success("删除成功");
              row.status = 0;
              if (
                localStorage.getItem("username") ===
                row.username
              ) {
                localStorage.removeItem("token");
                location.reload();
              }
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            showClose: true,
            message: "已取消删除",
          });
        });
    },
    // 重置密码
    onResetPassword (row) {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        type: "warning",
        message: h("p", null, [
          h("span", null, "您将重置用户 "),
          h("i", { style: "color: #059370" }, row.username),
          h("span", null, "  的密码"),
          /*  h("i", { style: "color: #059370" }, "123456"), */
          h("span", null, "，是否重置？"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          resetPsw(row.id).then((res) => {
            if (res.code === 0) {
              this.$message.success("重置成功");
            } else {
              this.$message.error("重置失败");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            showClose: true,
            message: "已取消重置密码",
          });
        });
    },
    // 当前页码改变
    onCurrentChange (page) {
      this.form.current = page;
      this.getUserListByField(this.form);
    },
    // 当前条数改变
    onSizeChange (size) {
      this.form.size = size;
      this.getUserListByField(this.form);
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 弹窗关闭时的回调
    onDialogClose (flag) {
      this.dialogVisible = false;
      if (flag) {
        this.getUserListByField(this.form);
      }
    },
    onSave () {
      this.$refs.addUser.onSave();
    },
    //获取头像
    getAvatar (path) {
      if (
        path &&
        ((path.toLowerCase()).indexOf("jpg") !== -1 || (path.toLowerCase()).indexOf("png") !== -1 || (path.toLowerCase()).indexOf("jpeg") !== -1)
      ) {
        return IMG_PREFIX + path;
      }
      return null;
    },
  },
  created () {
    this.onSearch();
  },
  mounted () {
    this.$nextTick(() => {
      this.computeHeight();
      window.addEventListener("resize", this.computeHeight, false);
    });
  },
  destroyed () {
    window.removeEventListener("resize", this.computeHeight);
  },
};
</script>
<style lang="scss" scoped>
.user-management {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  padding: 16px 20px;
  box-sizing: border-box;
  .avatarImg {
    vertical-align: middle;
    border-radius: 50%;
  }
}

.theme-light {
  .user-management {
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba($color: #343434, $alpha: 0.1);
  }
}
</style>